namespace $ {
	export class $shm_hitalama_quick_item_contract {
		
		title(): string {
			return ''
		}
		
	}
}
